module.exports = __webpack_public_path__ + "img/202.problem_broken_niagara.d8f7f142.svg";